import React from 'react';

import Flex from '@gojob/ui-bits/Flex';
import useTheme from '@gojob/ui-bits/styles/useTheme';
import Text from '@gojob/ui-bits/Text';

const useStyles = () => {
  const { spacing, breakpoint } = useTheme();
  return {
    root: {
      justifyContent: 'center',
      boxSizing: 'border-box',
      padding: spacing(0, 4),
    },
    container: {
      width: '100%',
      maxWidth: breakpoint.values.lg,
    },
  } as const;
};

interface DescriptionProps {
  children?: React.ReactNode;
}

const Description = (props: DescriptionProps) => {
  const { children } = props;
  const classes = useStyles();

  if (!children) {
    return null;
  }
  return (
    <Flex css={classes.root}>
      <Flex css={classes.container}>
        <Text css={{ whiteSpace: 'pre-wrap' }}>{children}</Text>
      </Flex>
    </Flex>
  );
};

export default Description;
